var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeadline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0007 4.3335C17.0458 4.3335 12.5683 4.3335 11.2635 7.14839C11.1514 7.39035 11.0568 7.64168 10.9806 7.90004C10.0942 10.9056 13.2602 14.3892 19.5923 21.3564L23.834 26.0002H28.1673L32.409 21.3564C38.7411 14.3892 41.9071 10.9056 41.0207 7.90004C40.9445 7.64168 40.8499 7.39035 40.7378 7.14839C39.433 4.3335 34.9555 4.3335 26.0007 4.3335Z",
    fill: "#00558C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.2635 44.8518C12.5683 47.6667 17.0458 47.6667 26.0007 47.6667C34.9555 47.6667 39.433 47.6667 40.7378 44.8518C40.8499 44.6098 40.9445 44.3585 41.0207 44.1001C41.9071 41.0945 38.7411 37.6109 32.409 30.6437L28.1673 26H23.834L19.5923 30.6437C13.2602 37.6109 10.0942 41.0945 10.9806 44.1001C11.0568 44.3585 11.1514 44.6098 11.2635 44.8518Z",
    fill: "#00558C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadline);
export default __webpack_public_path__ + "static/media/deadline.687f20d8b4bdc67cf1082ba6640c340b.svg";
export { ForwardRef as ReactComponent };